module.exports = __webpack_public_path__ + "static/media/Scenario2Header.933a5ba6.jpg";